import styled from "styled-components";

export const DropdownStyled = styled.div`
  position: relative;
  display: inline-block;

  .dropdown-trigger {
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .dropdown-menu {
    position: absolute; /* default; will be overridden to fixed with inline styles for robust layering */
    top: 120%;
    right: 0;
    background: ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? '#0C1E28' : '#ffffff'};
    border: 1px solid ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.08)'};
    color: ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? '#E6EDF2' : '#0B1A21'};
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.2);
    width: clamp(260px, 40vw, 360px);
    max-width: 92vw;
    z-index: 100000;
    list-style: none;
    padding: 0.5rem 0.5rem;
  }

  .dropdown-item {
    padding: 0.75rem 0.75rem;
    cursor: pointer;
    transition: background 0.2s ease;
    border-radius: 8px;
  }

  .dropdown-item:hover {
    background: ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)'};
  }

  /* Notifications specific styles */
  .dropdown-header {
    padding: 0.75rem 0.75rem;
    font-weight: 700;
    font-size: 0.95rem;
    color: ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? '#B8D1DA' : '#234'};
    border-bottom: 1px solid ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'};
    margin: 0 0 0.25rem 0;
  }

  .notification-item {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .notification-title {
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 2px;
  }

  .notification-body {
    font-size: 0.88rem;
    opacity: 0.9;
  }

  .notification-meta {
    font-size: 0.75rem;
    opacity: 0.7;
    margin-top: 4px;
  }

  .dropdown-footer {
    display: flex;
    gap: 8px;
    padding: 0.5rem 0.75rem 0.75rem;
    border-top: 1px solid ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'};
  }
    
`;

// Portal menu styled element to preserve theming/styling when rendered in document.body
export const DropdownMenuLayer = styled.ul`
  position: fixed;
  top: 0;
  right: 0;
  background: ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? '#0C1E28' : '#ffffff'};
  border: 1px solid ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.08)'};
  color: ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? '#E6EDF2' : '#0B1A21'};
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.2);
  width: clamp(260px, 40vw, 360px);
  max-width: 92vw;
  z-index: 100000;
  list-style: none;
  padding: 0.5rem 0.5rem;
  margin: 0;
  overflow: visible;

  /* caret pointer (border outline) */
  &::before {
    content: '';
    position: absolute;
    top: -9px;
    right: var(--caret-offset, 18px);
    border-style: solid;
    border-width: 0 9px 9px 9px; /* up-pointing caret (bottom colored) */
    border-color: transparent transparent
      ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.08)'}
      transparent;
    pointer-events: none;
  }

  /* caret pointer (inner fill) */
  &::after {
    content: '';
    position: absolute;
    top: -8px;
    right: var(--caret-offset, 18px);
    border-style: solid;
    border-width: 0 8px 8px 8px; /* up-pointing caret */
    border-color: transparent transparent
      ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? '#0C1E28' : '#ffffff'}
      transparent;
    pointer-events: none;
  }

  /* item base */
  .dropdown-item {
    padding: 0.75rem 0.75rem;
    cursor: pointer;
    transition: background 0.2s ease;
    border-radius: 8px;
  }
  .dropdown-item:hover {
    background: ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)'};
  }

  /* header */
  .dropdown-header {
    padding: 0.75rem 0.75rem;
    font-weight: 700;
    font-size: 0.95rem;
    color: ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? '#B8D1DA' : '#234'};
    border-bottom: 1px solid ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'};
    margin: 0 0 0.25rem 0;
  }

  /* notification item layout */
  .notification-item {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .notification-title {
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 2px;
  }
  .notification-body {
    font-size: 0.88rem;
    opacity: 0.9;
  }
  .notification-meta {
    font-size: 0.75rem;
    opacity: 0.7;
    margin-top: 4px;
  }

  /* footer actions */
  .dropdown-footer {
    display: flex;
    gap: 8px;
    padding: 0.5rem 0.75rem 0.75rem;
    border-top: 1px solid ${({ theme, $forceDark }) => ($forceDark || theme === 'dark') ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'};
  }
`;